import React from 'react';
import { loader } from 'graphql.macro';
import { useParams } from '@reach/router';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import {
  GET_SNAPSHOTS_AND_QUOTES,
  GET_SNAPSHOTS_AND_QUOTESVariables,
  GET_SNAPSHOTS_AND_QUOTES_account_items_policy_quotes
} from './graphql/__generated__/GET_SNAPSHOTS_AND_QUOTES';
import { SnapshotsAndQuotesTable } from '.';
import useDocumentDownload from '../../util/useDocumentDownload';
import redirectOnQuotesClick from '../../util/redirectOnQuotesClick';

const get_snapshots_and_quotes = loader(
  './graphql/Get_Snapshots_And_Quotes.graphql'
);

const get_quote_search_selection_behavior = loader(
  './graphql/Snapshots_And_Quotes_Get_Quote_Search_Selection_Behavior.graphql'
);

export interface historyProp {
  history?: boolean;
}

export default (showAll: historyProp) => {
  const { accountNumber, policyNumber } = useParams();
  const queryResult = useQuery<
    GET_SNAPSHOTS_AND_QUOTES,
    GET_SNAPSHOTS_AND_QUOTESVariables
  >(get_snapshots_and_quotes, {
    variables: {
      account_number: accountNumber,
      policy_number: policyNumber
    } as GET_SNAPSHOTS_AND_QUOTESVariables
  });

  const { error, data } = queryResult;

  let snapshotsAndQuotes:
    | GET_SNAPSHOTS_AND_QUOTES_account_items_policy_quotes[]
    | undefined;
  const { onDocumentClick, documentModal } = useDocumentDownload(
    accountNumber,
    'snapshot',
    'click-policySnapshotDocument'
  );
  if (data?.account?.items) {
    snapshotsAndQuotes = data.account.items[0]?.policy?.quotes?.filter(
      (
        snapshotOrQuote: GET_SNAPSHOTS_AND_QUOTES_account_items_policy_quotes | null
      ): snapshotOrQuote is GET_SNAPSHOTS_AND_QUOTES_account_items_policy_quotes => {
        return !!snapshotOrQuote;
      }
    );
  }

  const [redirectOnQuoteClickAction] = useLazyQuery(
    get_quote_search_selection_behavior,
    {
      onCompleted: redirectOnQuotesClick
    }
  );

  return (
    <>
      {documentModal}
      <SnapshotsAndQuotesTable
        error={error}
        snapshotsAndQuotes={snapshotsAndQuotes}
        onDocumentClick={onDocumentClick}
        accountNumber={accountNumber}
        policyNumber={policyNumber}
        {...showAll}
        redirectOnQuoteClickAction={redirectOnQuoteClickAction}
      />
    </>
  );
};
